<template>
    <client-page className="header--light">
        
        <sub-visual
        sh="기업소개"
        sh2="보도자료"
        tabActive="보도자료"
        bg="/images/sub/visual/sv1-4.jpg">
        </sub-visual>

        

           <div class="text-center color-white bg-black py-50 py-lg-74 w-100">
                <v-container>
                    <h3 class="tit font-weight-light font-italic" data-aos="fade-down">
                        신뢰할 수 있는 <strong class="font-weight-bold">세일즈웍스 코리아</strong>
                    </h3>
                    <p class="tit-txt mt-10 mt-lg-24" data-aos="fade-up">
                        국제적 네트워크와 체계적인 프로세스를 바탕으로 <br class="d-none d-md-block">
                        함께하는 모든 분께 신뢰를 드리고 있습니다.
                    </p>
                </v-container>
           </div>

           <section class="section">
                <v-container>
                    <div class="tit-wrap text-center">
                        <h3 class="tit">
                            보도자료
                        </h3>
                        <p class="tit-txt">
                            언론에서 바라본 세일즈웍스 코리아
                        </p>
                    </div>
                    <press-list />
                </v-container>
           </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PressList from "@/components/client/business/press-list.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        PressList,
    },
    data() {
        return {
            // searchKeys: ["제목+내용", "제목", "내용"],
            // filter: {
            //     searchKey: this.$route.query.searchKey || "",
            //     searchValue: this.$route.query.searchValue || "",
            // },
        }
    },
    methods: {
        async search() {
        }
    }
};
</script>

